import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot
} from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { Account } from './shared/account';


@Injectable({
  providedIn: 'root'
})
export class RoleGuardService implements CanActivate {

  constructor(private authService: MsalService) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    let expectedRole = route.data.expectedRole;
    let account: Account = this.authService.instance.getAllAccounts()[0];

    //account.idTokenClaims?.roles?  contains only 1 role right now even though its an array
    //expectedRole contains as many array values as I pass from the router module page
    //The below else if works...but really I can just hardcode one value = to account.idTokenClaims?.roles[0] and use that with an includes instead of the every/indexof

    if (!account.idTokenClaims?.roles) {
      window.alert('Token does not have roles claim. Please ensure that your account is assigned to an app role and then sign-out and sign-in again.');
      return false;
    }
    //else if (!account.idTokenClaims?.roles?.includes(expectedRole)) {
    else if (!expectedRole.includes(account.idTokenClaims?.roles[0])) {
    //else if (!account.idTokenClaims?.roles?.every(element => expectedRole.indexOf(element) > -1)) {
      window.alert('You do not have access as expected role is missing. Please ensure that your account is assigned to an app role and then sign-out and sign-in again.');
      return false;
    }

    return true;
  }
}
